<template>
  <div :class="$style.container">
    <div :class="$style.header">
      <div :class="$style.col">
        <div :class="[$style.row, $style.rowBig]">
          <div :class="$style.label">Заявитель:</div>
          <div :class="$style.value">
            <div :class="$style.icon">
              <app-avatar v-if="owner" :name="owner.name" :img="owner.avatar_url | imgPath" size="28px" />
            </div>
            {{ owner ? owner.name : '-' }}
          </div>
        </div>
        <div :class="$style.row">
          <div :class="$style.label">Телефон заявителя:</div>
          <div :class="$style.value">{{ owner ? owner.telephone || '-' : '-' }}</div>
        </div>
        <div :class="$style.row">
          <div :class="$style.label">Телефон для связи:</div>
          <div :class="$style.value">{{ additional.phone || '-' }}</div>
        </div>
      </div>
      <div :class="$style.col">
        <div :class="[$style.row, $style.rowBig]">
          <div :class="$style.label">Лицевой счет:</div>
          <div :class="$style.value">
            №{{ issue.apart.account_number }}
            <span :class="[$style.balance, balance >= 0 && $style.balancePlus]">(Баланс:  {{ balance | money }})</span>
          </div>
        </div>
        <div :class="$style.row">
          <div :class="$style.label">Всего заявок:</div>
          <div :class="$style.value">{{ totalIssues }} ({{ monthIssues }} заявка за текущий месяц)</div>
        </div>
        <div :class="$style.row">
          <button :class="$style.button" @click="goToUserIssues">Посмотреть заявки пользователя</button>
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
import parseJSON from "@/utils/parseJSON";

export default {
  name:     "IssueChat",
  props:    ['issue'],
  computed: {
    owner() {
      return this.issue.owner;
    },
    additional() {
      const { additional } = this.issue;
      return parseJSON(additional) || {};
    },
    balance() {
      return this.issue.apart.balance;
    },
    totalIssues() {
      const { owner } = this.issue;
      if (!owner) return '-';
      return +owner.task_count || 0;
    },
    monthIssues() {
      const { owner } = this.issue;
      if (!owner) return '-';
      return +owner.task_thismonth_count || 0;
    },
  },
  methods:  {
    goToUserIssues() {
      this.$router.push({
        name:  'uc_issues',
        query: {
          users_id: ['' + this.issue.owner.id],
          // type: 'all'
        },
      });
    },
  },
};
</script>

<style lang="scss" module>
.container {
  border: 1px solid #A9A9A9;
  height: 100%;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  background: #f3f3f3;
  border-bottom: 1px solid #A9A9A9;
  display: flex;
  padding: 14px 24px;
}

.col {
  flex: 1;
}

.row {
  display: flex;
  align-items: flex-start;
  font-size: 1rem;
  margin-bottom: 10px;

  :last-child {
    margin-bottom: 0;
  }
}

.rowBig {
  font-size: 1.25rem;
}

.label {
  font-weight: 600;
  margin-right: .3em;
  flex-shrink: 0;
}

.icon {
  display: inline-block;
}

.value {
  //display: flex;
  //align-items: flex-start;
}

.balance {
  font-weight: 600;
  margin-left: .3em;
  white-space: nowrap;
  color: rgba(var(--app-danger), 1);
}

.balancePlus {
  color: rgba(var(--app-success), 1);
}

.button {
  background-color: transparent;
  border: 0;
  border-radius: 0;
  appearance: none;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
}

</style>
